import './style.scss';

const LevelImageBlock = ({ imageSrc }: any) => {
    return (
        <div className={'level-block'}>
            <img
                className={'level-block__image'}
                src={imageSrc}
                alt={'value banner'}
            />
        </div>
    );
};

export default LevelImageBlock;